module.exports = __webpack_public_path__ + "static/media/version_pro.487fafc7.svg";